import { Filter, FilterType, FilterKey } from 'api-paths-cas';
import { isEqual, orderBy, uniqWith } from 'lodash';
import { UserRole } from '@/store/auth/types';
import { hasPerm, P } from '@/utilities/roles/permissions';
import { IGetFilterGroupsProps } from '../../types';

const key = FilterKey.AGENT_NAME;

const getAgentOptions = (agents: string[], filters: string[]) => {
  const options = agents?.map((agent: string) => {
    return {
      label: agent,
      value: agent,
      checked: filters.some(filter => filter === agent),
    };
  });

  options.push({
    label: 'Enroly',
    value: 'Enroly',
    checked: filters.some(filter => filter === 'Enroly'),
  });

  const sortedOptions = orderBy(options, [option => option.label.toLowerCase()], ['asc']);

  return uniqWith(sortedOptions, isEqual);
};

export const getAgentNameFilter = ({
  activeFilters,
  userRole,
  filterOptions,
}: IGetFilterGroupsProps): Filter | null => {
  const canFilterAgents = hasPerm(userRole || UserRole.Unknown, P.FILTER_AGENTS);
  const agentFilterOptions = filterOptions?.agent || [];

  if (!canFilterAgents) {
    return null;
  }

  const filters = activeFilters[key] ?? [];
  const options = getAgentOptions(agentFilterOptions || [], filters);

  return {
    name: 'Agent name',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: true,
    options: {
      SELECT_MANY: options,
    },
  };
};
